import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useNetworkingOptimized } from '@/hooks/useNetworkingOptimized';
import { useAuth } from '@/contexts/AuthContext';

interface NetworkingNotificationBadgeProps {
  children: React.ReactNode;
}

export const NetworkingNotificationBadge: React.FC<NetworkingNotificationBadgeProps> = ({ children }) => {
  const { user } = useAuth();
  const { networkingStats } = useNetworkingOptimized();

  if (!user) {
    return <>{children}</>;
  }

  // Source unique de vérité : utiliser networkingStats directement
  const totalNotifications = networkingStats.pendingRequests + networkingStats.unreadMessages;

  if (totalNotifications === 0) {
    return <>{children}</>;
  }

  return (
    <div className="relative inline-flex items-center">
      {children}
      <Badge variant="destructive" className="ml-2">
        {totalNotifications}
      </Badge>
    </div>
  );
};
